export type JsonPathExpression = string;
